import React from "react";
import { Button } from "primereact/button";
import MobileAlertBanner from "presentation/mobile/components/MobileAlertBanner";
import { TIMESHEET_STATUS_TONES, getStatusStyle } from "presentation/mobile/utils/status-styles.util";

interface WeeklyHeaderProps {
    periodLabel: string;
    status: string;
    isEditableStatus: boolean;
    canEdit: boolean;
    hasPendingKm: boolean;
    onSubmitClick: () => void;
    weekIndex: number;
    totalWeeks: number;
    onPrevWeek: () => void;
    onNextWeek: () => void;
}

const WeeklyHeader: React.FC<WeeklyHeaderProps> = ({
    periodLabel,
    status,
    isEditableStatus,
    canEdit,
    hasPendingKm,
    onSubmitClick,
    weekIndex,
    totalWeeks,
    onPrevWeek,
    onNextWeek,
}) => {
    const statusStyle = getStatusStyle(TIMESHEET_STATUS_TONES, status);

    return (

        <>
            {/* Cabeçalho do Período com Botão Submeter */}
            <div className="w-full px-3 pt-3 pb-2 flex justify-content-between align-items-center">
                <div className="flex align-items-center gap-2">
                    <span className="text-xl font-bold" style={{ color: "#0F172A" }}>
                        {periodLabel}
                    </span>
                    <span
                        className="badge-squircle"
                        style={{
                            color: statusStyle.color,
                            backgroundColor: statusStyle.bg,
                            border: `1px solid ${statusStyle.border}`,
                            fontSize: "0.75rem",
                        }}
                    >
                        {status}
                    </span>
                </div>

                {canEdit && (
                    <Button
                        label="Submeter"
                        icon="pi pi-send"
                        size="small"
                        className="border-round-lg text-xs font-semibold px-3 py-2"
                        style={{ backgroundColor: "#0084D1", border: "none" }}
                        onClick={onSubmitClick}
                    />
                )}
            </div>

            {/* Aviso quando o mapa está bloqueado por KM pendentes */}
            {hasPendingKm && isEditableStatus && (
                <MobileAlertBanner severity="warning" className="mx-3 mt-3">
                    Existe(m) mapa(s) de quilómetros pendente(s) de assinatura. Apenas após os assinar, poderá editar e submeter o seu mapa de horas.
                </MobileAlertBanner>
            )}

            {/* Dica de interação com toque longo */}
            {canEdit && (
                <MobileAlertBanner severity="info" className="mx-3 mt-2" style={{ padding: "0.5rem 0.75rem" }}>
                    Pressione longamente num card para gerir ou remover entradas
                </MobileAlertBanner>
            )}

            {/* Barra de Navegação de Semanas */}
            <div
                className="w-full px-3 py-2 flex justify-content-between align-items-center border-top-1 border-bottom-1"
                style={{ borderColor: "#e5e5e5" }}
            >
                <Button
                    icon="pi pi-chevron-left"
                    label="Semana Anterior"
                    text
                    size="small"
                    disabled={weekIndex === 0}
                    onClick={onPrevWeek}
                />
                <Button
                    icon="pi pi-chevron-right"
                    label="Próxima Semana"
                    iconPos="right"
                    text
                    size="small"
                    disabled={weekIndex >= totalWeeks - 1}
                    onClick={onNextWeek}
                />
            </div>
        </>
    );
};

export default WeeklyHeader;